// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useState } from 'react';
import SimpleBar from 'simplebar-react';
import { useLocation, Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faCog, faSignOutAlt, faTimes, faInbox } from '@fortawesome/free-solid-svg-icons';
import { Nav, Badge, Image, Button, Dropdown, Navbar } from '@themesberg/react-bootstrap';

import LogoTransparent from '../assets/img/logo_transparent.png';
import ProfilePicture from '../assets/img/team/profile-picture-3.jpg';

const Sidebar = () => {
    const location = useLocation();
    const { pathname } = location;
    const [show, setShow] = useState(false);
    const showClass = show ? 'show' : '';

    const onCollapse = () => setShow(!show);

    const NavItem = (props: any) => {
        const {
            title,
            link,
            external,
            target,
            icon,
            image,
            badgeText,
            badgeBg = 'secondary',
            badgeColor = 'primary',
        } = props;
        const classNames = badgeText ? 'd-flex justify-content-start align-items-center justify-content-between' : '';
        const navItemClassName = link === pathname ? 'active' : '';
        const linkProps = external ? { href: link } : { as: Link, to: link };

        return (
            <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
                <Nav.Link {...linkProps} target={target} className={classNames}>
                    <span>
                        {icon ? (
                            <span className="sidebar-icon">
                                <FontAwesomeIcon icon={icon} />{' '}
                            </span>
                        ) : null}
                        {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

                        <span className="sidebar-text">{title}</span>
                    </span>
                    {badgeText ? (
                        <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">
                            {badgeText}
                        </Badge>
                    ) : null}
                </Nav.Link>
            </Nav.Item>
        );
    };

    return (
        <>
            <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
                <Navbar.Brand className="me-lg-5" as={Link} to={'/'}>
                    <img style={{ height: '50px' }} alt="logo" className="navbar-brand-light" src={LogoTransparent} />
                    {/* <Image src={ReactHero} className="navbar-brand-light" /> */}
                </Navbar.Brand>
                <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
                    <span className="navbar-toggler-icon" />
                </Navbar.Toggle>
            </Navbar>
            <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
                <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
                    <div className="sidebar-inner px-4 pt-3">
                        <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
                            <div className="d-flex align-items-center">
                                <div className="user-avatar lg-avatar me-4">
                                    <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                                </div>
                                <div className="d-block">
                                    <h6>Hi, Jane</h6>
                                    <Button as={Link} variant="secondary" size="xs" to={'/'} className="text-dark">
                                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                                    </Button>
                                </div>
                            </div>
                            <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                                <FontAwesomeIcon icon={faTimes} />
                            </Nav.Link>
                        </div>
                        {/** PAGES  */}
                        <Nav className="flex-column pt-3 pt-md-0">
                            <img className="pb-2" alt="logo" src={LogoTransparent} />

                            {/* <NavItem image={LogoTransparent} /> */}
                            <NavItem title="Dashboard" badgeText="" link={'/'} icon={faChartPie} />
                            <NavItem title="Events" badgeText="" link={'/events'} icon={faChartPie} />
                            <NavItem external title="Students" link={'/students'} badgeText="" icon={faInbox} />
                            <NavItem external title="Products" link={'/products'} badgeText="" icon={faInbox} />
                            <NavItem external title="Courses" link={'/courses'} badgeText="" icon={faInbox} />
                            <NavItem external title="Testimonials" link={'/testimonials'} badgeText="" icon={faInbox} />

                            {/* <NavItem external title="Staff" link={'/staff'} badgeText="4" icon={faInbox} />

                            <NavItem external title="Scale" link={'/scale'} icon={faInbox} /> */}

                            <Dropdown.Divider className="my-3 border-indigo" />
                            <NavItem title="Settings" icon={faCog} link={'/settings'} />
                        </Nav>
                    </div>
                </SimpleBar>
            </CSSTransition>
        </>
    );
};

export default Sidebar;
